<template>
    <div class="layout-container-box">
        <el-header class="layout-header">
            <Header>
                <template #header-brand>
                    <BreadCrumb :breadList="breadLists" />
                </template>
            </Header>
        </el-header>
        <el-scrollbar class="layout-main-content" id="content_box">
            <div class="pd-20">
                <div class="create-tags-container">
                    <el-card class="mg-b-16">
                        <template #header>
                            <div class="card-header">
                                <span class="card-name">标签树基本信息</span>
                            </div>
                        </template>
                        <div class="form-container">
                            <el-form
                                ref="formRef"
                                :model="tagsBaseInfo"
                                :rules="tagsBaseInfoRule"
                                label-width="120px"
                                class="user-form-box mg-t-24"
                            >
                                <el-form-item label="标签树名称" prop="name">
                                    <!-- <el-input v-model="tagsBaseInfo.name" placeholder="请输入"></el-input> -->
                                    <span>{{tagsBaseInfo.name}}</span>
                                </el-form-item>
                                <el-form-item label="描述" prop="desc">
                                    <!-- <el-input v-model="tagsBaseInfo.desc" maxlength="100" show-word-limit type="textarea" placeholder="请输入"></el-input> -->
                                    <span>{{tagsBaseInfo.desc}}</span>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-card>
                    <div class="bottom-submit-box pd-16 mg-t-12">
                        <el-row justify="end">
                            <el-col :span="3">
                                <el-button size="small" plain @click="goback">返回</el-button>
                                <el-button size="small" type="primary" @click="goEdit">编辑</el-button>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
import Header from '../../Layout/components/Header.vue';
import BreadCrumb from '../../components/BreadCrumb/index.vue';
import {ref, getCurrentInstance, onBeforeMount} from 'vue'
import { Ajax, MessageTips } from '../../utils'
import { useRouter, useRoute } from 'vue-router'
export default {
    components: {
        Header,
        BreadCrumb
    },
    setup() {
        const breadListsRef = ref([
            {
                name: '标签',
                path: {
                    name: 'Tags'
                }
            },
            {
                name: '标签详情'
            }
        ])
        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const route = useRoute();
        const tagsBaseInfoRef = ref({
            name: '',
            desc: ''
        })
        const tagsBaseInfoRule = {
            name: [
                {
                    required: true,
                    message: '请输入标签树名称',
                    trigger: 'blur'
                }
            ]
        }

        onBeforeMount(() => {
            let id =route.query.id;
            Ajax.POST({
                // url: `/admin/label_tree/${route.query.id}`
                url: `/admin/tags`
            }).then(res => {
                
                if(res.data.code === 200) {
                    // tagsBaseInfoRef.value = res.data.data;
                    let data = res.data.data;
                    let targetValue={};
                    data.map(item=>{
                        if(item.id==id){
                            targetValue=item
                        }
                    })
                    tagsBaseInfoRef.value = targetValue;
                }
            })
        })

        // 底部
        const goback = () => {
            router.back()
        }
        const goEdit = () => {
            router.push({
                name: 'TagsEdit',
                query: {
                    id: route.query.id
                }
            })
        }
        return {
            breadLists: breadListsRef,
            tagsBaseInfo: tagsBaseInfoRef,
            tagsBaseInfoRule,
            goback,
            goEdit
        }
    }
}
</script>

<style lang="less" scoped>
    .create-tags-container {
        .user-form-box {
            width: 50%;
        }
        .bottom-submit-box {
            background-color: #fff;
        }
        .el-tag + .el-tag {
            margin-left: 10px;
        }
        .button-new-tag {
            margin-left: 10px;
            height: 32px;
            line-height: 30px;
            padding-top: 0;
            padding-bottom: 0;
        }
        .input-new-tag {
            width: 90px;
            margin-left: 10px;
            vertical-align: bottom;
        }
    }
</style>